import { clearToken, getToken } from "@/utils/auth";
import { PLATFORMS, ROLE_DIST } from "@/utils/enum";
import { fetchSubLogin } from "@/api/login";
import { Base64 } from "js-base64";
import { env } from "@/utils/config";
import { isObject } from "@/utils/is";
export default {
  methods: {
    //根据后台返回的do做操作
    //todo：后台操作指示
    //logined：是否已登录
    handleTodo(todo = "", logined = true) {
      const { redirect, platform, role, phone } = this.$store.state.user;
      console.log(platform, "platform");
      console.log(redirect, "redirect");
      console.log(role, "role");
      

      if (todo === "register") {
        this.$confirm("手机号不存在，是否去注册页注册", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.toRegister();
          })
          .catch(() => {
            console.log("取消");
          });
      } else if (todo === "platform") {
        //去选择平台页面
        this.$router.push({
          name: "WorkbenchHome",
        });
      } else if (todo === "role") {
        //去选择平台下的角色页面
        this.$router.push({
          name: "WorkbenchRole",
        });
      } else if (todo === "login") {
        clearToken();
        this.$store.commit("user/CLEAR_DATA");
        //过期，去登录页
        this.$router.replace({
          name: "Login",
          query: {
            redirect,
            platform,
            role,
          },
        });
      } else if (todo === "redirect") {
        //登录成功，返回到来源地址
        console.log("redirect");
        fetchSubLogin({
          common_token: getToken(),
          platform,
          role,
        }).then(res => {
          console.log(res, "sub login");
          const { code, data } = res;
          if (code === 0) {
            const { token } = data;
            
            if (platform === "zxdx") {
              const {
                isSingle,
                isSpecialize,
                isTip,
                singleRange,
                // ruleList,
                // token,
                userType,
              } = token;
              const zxdxCookieData = {
                expires: 3,
                domain: env === "production" ? ".hxylt.org.cn" : ".doclive.cn",
              };

              this.$cookie.set("token_v3", token.token, zxdxCookieData);
              this.$cookie.set("userType", userType, zxdxCookieData);
              this.$cookie.set("isTip", isTip, zxdxCookieData);
              this.$cookie.set("phone", phone, zxdxCookieData);
              this.$cookie.set("major", isSpecialize, zxdxCookieData);
              this.$cookie.set("single", isSingle, zxdxCookieData);
              this.$cookie.set("singleRange", singleRange, zxdxCookieData);
            }
            if (platform === "hospital") {
              const hospitalCookieData = {
                expires: 3,
                domain: env === "production" ? ".hxylt.org.cn" : ".doclive.cn",
              };
              if (role === "doctor") {
                this.$cookie.set(
                  "tokenDoctor",
                  token.token,
                  hospitalCookieData
                );
                this.$cookie.set("userInfo", token, hospitalCookieData);
                this.$cookie.set("role", "2", hospitalCookieData);
              } else if (role === "patient") {
                this.$cookie.set(
                  "tokenPatient",
                  token.token,
                  hospitalCookieData
                );
                this.$cookie.set("userInfo1", token, hospitalCookieData);
                this.$cookie.set("role", "1", hospitalCookieData);
                this.$cookie.set("userName", token.name, hospitalCookieData);
              } else if (role === "admin") {
                console.log(111);
                this.$cookie.set(
                  "USER_INFO",
                  Base64.encode(JSON.stringify(token)),
                  hospitalCookieData
                );
                this.$cookie.set(
                  "USER_INFO_TIME",
                  this.$moment().format("x"),
                  hospitalCookieData
                );
                this.$cookie.set(
                  "tokenManage",
                  token.token,
                  hospitalCookieData
                );
              }
            }
            if (platform === "pccm") {
              if (role === "hospital") {
                const pccmCookieData = {
                  expires: 3,
                  domain: env === "production" ? ".hxylt.org.cn" : ".doclive.cn",
                };
                if (isObject(token)) {
                  const {
                    access_token,
                    token_type,
                    jeesite_session_pccm_id,
                    hospital,
                    user,
                  } = token;

                  this.$cookie.set(
                    "access_token",
                    `${token_type} ${access_token}`,
                    pccmCookieData
                  );
                  this.$cookie.set(
                    "affirm_status",
                    hospital.affirm_status,
                    pccmCookieData
                  );
                  this.$cookie.set(
                    "jeesite.session_pccm.id",
                    jeesite_session_pccm_id,
                    pccmCookieData
                  );
                  this.$cookie.set("level", user.level || "3", pccmCookieData);

                  this.$cookie.set(
                    "uc_token",
                    `${data.uc_token}`,
                    pccmCookieData
                  );
                  console.log(data.uc_token,'token');
                } else {
                  this.$message({
                    message: "绑定失败，请重试",
                    type: "error",
                  });
                  // return;
                }
              } else if (role === "specialist") {
                if (isObject(token)) {
                  const { access_token, token_type } = token;
                  this.$cookie.set(
                    "PCCM_TOKEN",
                    `${token_type} ${access_token}`,
                    {
                      domain:
                        env === "production" ? ".hxylt.org.cn" : ".doclive.cn",
                      path: "/",
                    }
                  );
                } else {
                  this.$message({
                    message: "绑定失败，请重试",
                    type: "error",
                  });
                  return;
                }
              } else if (role === "admin") {
                const pccmCookieData = {
                  expires: 3,
                  domain: env === "production" ? ".hxylt.org.cn" : ".doclive.cn",
                };
                const {
                  access_token,
                  token_type,
                  jeesite_session_pccm_id,
                } = token;

                this.$cookie.set(
                  "admin_token",
                  `${token_type} ${access_token}`,
                  pccmCookieData
                );
                this.$cookie.set(
                  "jeesite.session_pccm.id",
                  jeesite_session_pccm_id,
                  pccmCookieData
                );
              }
            }

            // 间质性肺疾病
            if (platform === "ild") {
              console.log('ild_direct',role)
              
              if (role === "hospital") {
                const pccmCookieData = {
                  expires: 3,
                  domain: env === "production" ? ".hxylt.org.cn" : ".doclive.cn",
                };

                console.log(pccmCookieData,'$$',token);
                
                if (isObject(token)) {
                  const {
                    access_token,
                    token_type,
                    jeesite_session_pccm_id,
                    hospital,
                    user,
                  } = token;
                  console.log(token)
                  this.$cookie.set(
                    "access_token",
                    `${token_type} ${access_token}`,
                    pccmCookieData
                  );
                  this.$cookie.set(
                    "affirm_status",
                    1,
                    pccmCookieData
                  );
                  this.$cookie.set(
                    "jeesite.session_pccm.id",
                    jeesite_session_pccm_id,
                    pccmCookieData
                  );
                  this.$cookie.set("level", user.level || "3", pccmCookieData);
                } else {
                  this.$message({
                    message: "绑定失败，请重试",
                    type: "error",
                  });
                  return;
                }
              } else if (role === "specialist") {
                if (isObject(token)) {
                  const { access_token, token_type } = token;
                  this.$cookie.set(
                    "ILD_TOKEN",
                    `${token_type} ${access_token}`,
                    {
                      domain:
                        env === "production" ? ".hxylt.org.cn" : ".doclive.cn",
                      path: "/",
                    }
                  );
                } else {
                  this.$message({
                    message: "绑定失败，请重试",
                    type: "error",
                  });
                  return;
                }
              } else if (role === "admin") {
                const pccmCookieData = {
                  expires: 3,
                  domain: env === "production" ? ".hxylt.org.cn" : ".doclive.cn",
                };
                const {
                  access_token,
                  token_type,
                  jeesite_session_pccm_id,
                } = token;

                this.$cookie.set(
                  "admin_token",
                  `${token_type} ${access_token}`,
                  pccmCookieData
                );
                this.$cookie.set(
                  "jeesite.session_pccm.id",
                  jeesite_session_pccm_id,
                  pccmCookieData
                );
              }
            }
            if (platform === "hxylt") {
              const hxyltCookieData = {
                expires: 2,
                domain: env === "production" ? ".hxylt.org.cn" : ".doclive.cn",
              };

              if (isObject(token)) {
                const { hospital_session, api_data } = token;

                this.$cookie.set(
                  "USER_INFO",
                  Base64.encode(JSON.stringify(api_data)),
                  hxyltCookieData
                );
                // this.$cookie.set("acw_tc", acw_tc, hxyltCookieData);
                this.$cookie.set(
                  "v2_hospital_session",
                  hospital_session,
                  hxyltCookieData
                );
              } else {
                this.$message({
                  message: "绑定失败，请重试",
                  type: "error",
                });
                return;
              }
            }
            if (platform === "www") {
              // 呼吸联合体
              const wwwCookieData = {
                expires: 2,
                domain: env === "production" ? ".hxylt.org.cn" : ".doclive.cn",
              };

              console.log("==wwwCookieData==", wwwCookieData);

              if (role === "doctor") {
                this.$cookie.set("doctorToken", token, wwwCookieData);
              } else if (role === "patient") {
                this.$cookie.set("patientToken", token, wwwCookieData);
              } else if (role === "admin") {
                this.$cookie.set("adminToken", token, wwwCookieData);
              }
            }
            this.redirectUrl();
          }
        });
      } else if (todo === "bind_none") {
        //平台无此手机，去创建或绑定其他
        this.$router.push({
          name: "WorkbenchBind",
        });
      } else if (todo === "bind_exist") {
        //平台有此手机，去绑定或绑定其他
        this.$router.push({
          name: "WorkbenchBind",
        });
      } else if (todo === "bind_supply") {
        // 平台注册了，补充信息
        this.$router.push({
          name: "WorkbenchBind",
        });
      } else if (todo === "bind_admin") {
        //绑定管理员
        console.log("admin");
        this.$router.push({
          name: "WorkbenchBindAdmin",
        });
      }
    },
    // 跳转路由
    redirectUrl() {
      const { platform, role } = this.$store.state.user;
      // 如果通过redirect返回，可能和用户点击的角色不一致，返回页面有问题
      //   if (redirect) {
      //     window.location.href = decodeURIComponent(redirect);
      //   } else {
      //   }
      const platformInfo = PLATFORMS[platform];

      const { role_enum } = platformInfo;

      const roleInfo = ROLE_DIST[role_enum][role];

      if (roleInfo && roleInfo.redirect) {
        window.location.href = roleInfo.redirect;
      }
    },
    toRegister() {
      const { platform, role } = this.$store.state.user;
      this.$router.push({
        name: "Register",
        query:{
          platform:platform,
          role:role
        }
      });
    },
  },
};
